import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20luxurious%20golden%20geometric%20waves%20on%20dark%20elegant%20background%2C%20warm%20amber%20gradients%20blending%20with%20deep%20charcoal%2C%20minimalist%20sophisticated%20financial%20theme%2C%20smooth%20flowing%20lines%2C%20premium%20atmospheric%20composition%20with%20soft%20light%20particles&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
          <div className="w-2 h-2 rounded-full bg-primary-400 animate-pulse"></div>
          <span className="text-sm text-primary-200 font-medium">已服务 50万+ 用户，累计创造收益 30亿+</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-6 leading-tight">
          磁力金牛
          <br />
          <span className="text-primary-300">强力吸金的财富增长利器</span>
        </h1>

        <p className="text-lg md:text-xl text-background-200/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          专为追求稳定收益与爆发式增长的用户打造的核心工具，凭借独特的吸金机制与智能策略，
          帮助您轻松实现财富积累、资产翻倍。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/register"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-base transition-all duration-300 whitespace-nowrap"
          >
            立即了解完整方案
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/cases"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/30 rounded-lg text-base transition-all duration-300 whitespace-nowrap"
          >
            查看成功案例
            <i className="ri-arrow-right-up-line ml-2"></i>
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { value: '50万+', label: '活跃用户' },
            { value: '30亿+', label: '累计收益' },
            { value: '99.7%', label: '策略执行率' },
            { value: '4.9/5', label: '用户好评' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-bold text-primary-300">{stat.value}</div>
              <div className="text-sm text-background-300/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}